import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "updateRejectionCodeSet";
export var useUpdateRejectionCodeSet = function () {
    var dispatch = useDispatch();
    var updatedRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var updatingRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorUpdateRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var updateRejectionCodeSet = function (id, body) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PUT",
            path: "/billing/Api/V1/RejectionCodes/".concat(id),
            body: body,
            // extraHeaders: getRejectionCodesUserIdHeader(),
        }));
    };
    var clearUpdateRejectionCodeSet = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        updateRejectionCodeSet: updateRejectionCodeSet,
        clearUpdateRejectionCodeSet: clearUpdateRejectionCodeSet,
        updatedRejectionCodeSet: updatedRejectionCodeSet,
        updatingRejectionCodeSet: updatingRejectionCodeSet,
        errorUpdateRejectionCodeSet: errorUpdateRejectionCodeSet,
    };
};
